import s from './ProposalThumbnail.scss'

const ProposalThumbnail = ({ thumbnailUrl }) =>
  thumbnailUrl ? (
    <img className={s.fileThumbnail} src={thumbnailUrl} />
  ) : (
    <div className={s.fileThumbnailPlaceholder} />
  )

export default ProposalThumbnail
